export default __webpack_public_path__ + "static/media/icon-depotPair.51356d5f.svg";